// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fade-enter-active[data-v-066d2991],\n.fade-leave-active[data-v-066d2991] {\n  -webkit-transition: 0.2s;\n  transition: 0.2s;\n}\n.fade-enter[data-v-066d2991],\n.fade-leave-to[data-v-066d2991] {\n  opacity: 0;\n}\n[dir] .fade-enter[data-v-066d2991], [dir] .fade-leave-to[data-v-066d2991] {\n  -webkit-transform: translateY(-20px);\n          transform: translateY(-20px);\n}", ""]);
// Exports
module.exports = exports;
